export const ERRORS = {
  POSTCODE_INVALID: "Invalid postcode. Please try again."
}

export const PRICE_ERRORS = {
  LOADING: "Your price is on its way.",
  /**
   * @todo  NO_LOCATION not used, text 'postcode' needs to be link
   */
  NO_LOCATION: "Enter your postcode to see accurate pricing in your area.",
  LAST_RESORT: "Price unavailable. Please contact your local Dealer."
}

export const SERVICE_SCHEDULE_ERRORS = {
  NOTFOUND: "Unfortunately we were unable to identify your vehicle from the details entered, or no service data exists. Please verify the vehicle details entered and try again, or contact your local Mazda dealer.",
  MULTIPLERESULTS: "Sorry, no result can be displayed because more than one result exists in Mazda’s database. Please enter your VIN and try again or contact your local Mazda dealer."
}

export const GEO_ERRORS = {
  // Internal
  // comment out to remove errors from client side

  // // Could not load geocoding functionality
  // NO_GEOCODER: 'Could not access your location',
  // // Could not load geolocation functionality
  // NO_GEOLOCATION: 'Could not access your location',
  // // Could not find post code or location
  POSTCODE_NOT_FOUND: "Invalid postcode. Please try again.",
  LOCATION_NOT_FOUND: "Invalid postcode. Please try again."
  //
  // // Geocoder status via Google Maps Geocoder API
  // // https://developers.google.com/maps/documentation/geocoding/intro#StatusCodes
  //
  // GEOCODER_ZERO_RESULTS: 'Could not find your location',
  // GEOCODER_OVER_QUERY_LIMIT: 'Could not access your location',
  // GEOCODER_REQUEST_DENIED: 'Could not access your location',
  // GEOCODER_INVALID_REQUEST: 'Could not access your location',
  // GEOCODER_UNKNOWN_ERROR: 'Could not access your location',
  //
  // // Geolocation error codes via browser geolocationAPI
  // // https://developer.mozilla.org/en-US/docs/Web/API/PositionError
  //
  // // User denied access to location
  // GEOLOCATION_1: 'Location access denied',
  // // There was error attempting to find user location
  // GEOLOCATION_2: 'Could not access your location',
  // // Attempts to find user location timed out
  // GEOLOCATION_3: 'Could not access your location',
  //
  // // For all else
  // default: 'Could not access your location'
}

// Register Interest
// Book-service
export const FORM_ERRORS = {
  // PERSONAL INFORMATION
  TITLE_REQUIRED: "Please select a title from the drop-down list.",
  SELECT_REQUIRED: "Please select one from the drop-down list.",
  PROFANITY_FILTER: "Your input has triggered the profanity filter, please try again",
  FIRSTNAME_MAXLENGTH: "First name must be shorter than 30 characters",
  FIRSTNAME_SPECIAL_CHARACTERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  FIRSTNAME_SPECIAL_CHARACTERS_POSITION: "Please use only letters (a-z) for the first and last character of your name.",
  FIRSTNAME_NUMBERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  FIRSTNAME_REQUIRED: "Please enter a first name.",
  LASTNAME_MAXLENGTH: "Last name must be shorter than 50 characters",
  LASTNAME_SPECIAL_CHARACTERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  LASTNAME_SPECIAL_CHARACTERS_POSITION: "Please use only letters (a-z) for the first and last character of your name.",
  LASTNAME_NUMBERS: "Sorry, only letters (a-z), apostrophes (') or hyphens (-) are allowed.",
  LASTNAME_REQUIRED: "Please enter a last name.",
  PHONE_NUMBER_AREACODE_INVALID: "Please enter a valid landline or mobile number using the correct area code.",
  PHONE_NUMBER_INVALID: "Please enter a valid landline or mobile number using the correct area code.",
  MOBILE_NUMBER_INVALID: "Please enter a valid mobile number",
  PHONE_NUMBER_REQUIRED: "Please enter your phone number.",
  PHONE_EXTENSION_INVALID: "The extension number you have entered is not valid. Please ensure it does not exceed 6 digits.",
  MOBILE_NUMBER_REQUIRED: "Please enter your mobile number.",
  EMAIL_MAXLENGTH: "Email is too long.",
  EMAIL_INVALID: "Please enter a valid email address.",
  EMAIL_REQUIRED: "Please enter an email address.",
  PASSWORD_REQUIRED: "Please enter a password.",
  PASSWORD_MAXLENGTH: "Password is too long.",
  PASSWORD_MINLENGTH: "Password is too short.",
  PASSWORD_CASE: "Password must contain atleast one uppercase and one lowercase letter.",
  PASSWORD_NUMBER_SYMBOL: "Password must contain atleast one number or symbol.",
  VIN_INVALID: "Please enter valid VIN number.",
  REGISTRATION_INVALID: "Please enter valid registration number.",
  MODEL_REQUIRED: "Please select a model from the drop-down list.",
  PRIVACY_POLICY_REQUIRED: "This is a mandatory field",
  OPTIN_REQUIRED: "This is a mandatory field",
  MODEL_FREETEXT_REQUIRED: "Please enter a model.",
  ODOMETER_REQUIRED: "Please enter odometer value.",
  ODOMETER_INVALID: "Please enter odometer value as a whole number.",
  REGO_OR_VIN_REQUIRED: "Please enter a valid registration or VIN.",
  TOPIC_REQUIRED: "Please select an enquiry topic from the drop-down list.",
  TIME_INVALID: "Please enter time in the format HH/MM.",
  LOCATION_REQUIRED: "Please enter your postcode or tell us which suburb you live in.",
  ADDRESS_REQUIRED: "Please enter your address.",
  LOCATION_INVALID: "Please enter a valid postcode or suburb.",
  ADDRESS_LOCATION_INVALID: "Please enter a full address.",
  STATE_REQUIRED: "Please select your state.",
  ADDRESS_INVALID: "Please enter a valid address.",
  ADDRESS1_REQUIRED: "Please enter an address",
  ADDRESS2_REQUIRED: "Please enter a suburb",
  ADDRESS3_REQUIRED: "Please enter a postcode",
  DEALERS_NO_POSTCODE: "Enter your postcode above and we’ll give you a list of your local Mazda Dealerships."
}

export const DEALER_ERRORS = {
  FIRST_VISIT: "",
  NO_DEALERS_FOUND: "Sorry, we can't seem to find the Dealership you're looking for. Please try again."
}

export const SEARCH_ERRORS = {
  API_ERROR: "Sorry, there was an error with your search. Please try again later."
}

export const MYMAZDA_ERRORS = {
  ACCOUNT_RESEND_CHANGE_EMAIL: "Verification email re-sent. Check your inbox.",
  ACCOUNT_RESEND_CHANGE_EMAIL_FAILED: "Sorry, verification email could not be re-sent. Please try again later.",
  ACCOUNT_CHANGE_EMAIL_REQUESTED: "Verification email sent. Check your inbox.",
  ACCOUNT_PERSONAL_DETAILS_UPDATED: "Personal details updated.",
  ACCOUNT_PASSWORD_UPDATED: "Password changed.",
  VEHICLE_DEACTIVATE_SUCCESS: "Your account was successfully deactivated.",
  VEHICLE_DEACTIVATE_FAILED: "Sorry, your account could not be deactivated at this time. Please try again later.",
  VEHICLE_ADD_TRANSFER_REQUESTED: ({
    nameplate,
    rego
  }) => `${nameplate} [${rego || "Registration number not available"}] vehicle transfer requested.`,
  VEHICLE_ADD_SUCCESS: ({
    nameplate,
    rego
  }) => `${nameplate} [${rego || "Registration number not available"}] added to your vehicles.`,
  VEHICLE_ADD_FAILED: ({
    nameplate,
    rego,
    error
  }) => `${nameplate} [${rego || "Registration number not available"}] could not be added. ${error}`,
  VEHICLE_REMOVE_SUCCESS: ({
    nameplate,
    registrationNumber
  }) => `Your ${nameplate} [${registrationNumber}] has been removed.`,
  VEHICLE_REMOVE_FAILED: ({
    nameplate,
    registrationNumber,
    error
  }) => `Your ${nameplate} [${registrationNumber}] could not be removed. ${error}.`
}



// WEBPACK FOOTER //
// ./src/constants/errors/index.js